export enum AvailableLanguages {
  DE = 'de',
  EN = 'en',
  FR = 'fr',
  IT = 'it',
  RM = 'rm',
}
